import { H1, LeadParagraph, Main } from "govuk-react";
import React, { memo, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { PreApplicationExternalInsertRecordFailResult } from "@shared/mirage/contracts/PrePublicPortal";
import { PrePublicPortalWLRoutingService } from "@prePublicPortalWestLindsay/services/PrePublicPortalWLRoutingService";

const router = new PrePublicPortalWLRoutingService();

export const PrePpWlSubmitError = memo(() => {
    const location = useLocation();
    const { state }: { state: PreApplicationExternalInsertRecordFailResult } = location;

    useEffect(() => {
        if (!state) {
            document.location.href = router.Root;
        }
        return () => {
            location.state = undefined;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state]);

    return (
        <Main>
            <H1>Something went wrong</H1>
            <LeadParagraph>{state?.errorMsg || ""}</LeadParagraph>
        </Main>
    );
});
